"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ShowMoreItems;
var _react = _interopRequireDefault(require("react"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/chevron--up/16"));
var _2 = _interopRequireDefault(require("@carbon/icons-react/lib/chevron--down/16"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ".show-more {\n  font-family: Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  display: flex;\n  justify-content: space-between;\n  padding-right: 20px;\n  padding-bottom: 12px;\n  cursor: ns-resize; }\n";
  const fileName = "ShowMoreItems_ShowMoreItems";
  const element = document.querySelector("style[data-sass-component='ShowMoreItems_ShowMoreItems']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
function ShowMoreItems(_ref) {
  let {
    showMore,
    setShowMore,
    translate
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "show-more sia-padding-02-left sia-border-01-bottom",
    onClick: () => setShowMore(!showMore)
  }, /*#__PURE__*/_react.default.createElement("div", null, showMore ? translate('benchmarking.filter-area.show-less') : translate('benchmarking.filter-area.show-more')), showMore ? /*#__PURE__*/_react.default.createElement(_.default, null) : /*#__PURE__*/_react.default.createElement(_2.default, null));
}